module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"SG Code Campus","short_name":"SGCC","start_url":"/","background_color":"#1B75BC","theme_color":"#F37021","display":"standalone","icon":"src/assets/images/sgcc-logo.png"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
